export interface OrderData {
    brandName?: string;
    brandLogoUrl?: string;
    cardBackgroundColor?: string;
    cardTextColor?: string;
    items: Array<{ label: string; quantity: number }>;
    totalAmountFormatted: string;
    cashbackAmountFormatted?: string;
    cashbackDescription?: string;
    conditions?: Array<{ text: string; shouldBeCrossedOut?: boolean }>;
    secondaryConditions?: Array<{ text: string; shouldBeCrossedOut?: boolean }>;
    conditionsOfUseUrl?: string;
}

export function decodeOrderData(encoded: string | null): OrderData | null {
    if (!encoded) return null;
    try {
        const bytes = Uint8Array.from(atob(encoded), c => c.charCodeAt(0));
        const parsed = JSON.parse(new TextDecoder().decode(bytes));
        if (parsed.conditions) {
            parsed.conditions = parsed.conditions.map(
                (condition: string | { text: string; shouldBeCrossedOut?: boolean }) =>
                    typeof condition === 'string' ? { text: condition } : condition
            );
        }
        if (parsed.secondaryConditions) {
            parsed.secondaryConditions = parsed.secondaryConditions.map(
                (condition: string | { text: string; shouldBeCrossedOut?: boolean }) =>
                    typeof condition === 'string' ? { text: condition } : condition
            );
        }
        return parsed;
    } catch {
        return null;
    }
}
